import { defineComponent } from "vue";

import { COMPONENT_NAME } from "./attributes";

import { AdminHeader } from "../header";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    AdminHeader,
  },
  computed: {
    isViewShow(): boolean {
      return !!this.$projectServices.userRepo.userInfo.id;
    },
  },
});
